// 🔧 SalesPageLayout.js
// ✅ Purpose: Shared LGV Sales Automation page layout
// ✅ Features:
// - Provides consistent page header for Sales Automation pages
// - Keeps LGV standard Bootstrap container/card styling
// - Supports title, subtitle, action buttons, and status messages
// - Keeps pages cleaner by removing repeated header/status markup
// - Does NOT perform data loading or business logic
// - Fully block-commented for clarity and future devs

import React from "react";

// ✅ SalesPageLayout
// ✅ Purpose: Standard wrapper for Sales Automation pages
function SalesPageLayout({
  title,
  subtitle,
  actions,
  status,
  children,
}) {
  // ✅ Returns a Bootstrap-style status class
  const getStatusAlertClass = () => {
    if (!status) return "";

    if (status.type === "success") return "alert alert-success";
    if (status.type === "error") return "alert alert-danger";
    if (status.type === "warning") return "alert alert-warning";

    return "alert alert-info";
  };

  return (
    <div className="container mt-4 mb-5">
      <div className="card mb-3">
        <div className="card-body">
          <div className="d-flex flex-column flex-md-row justify-content-between align-items-md-start gap-3">
            <div>
              <h2 className="mb-1">{title}</h2>

              {subtitle && (
                <p className="text-muted mb-0">
                  {subtitle}
                </p>
              )}
            </div>

            {actions && (
              <div className="d-flex flex-wrap gap-2">
                {actions}
              </div>
            )}
          </div>
        </div>
      </div>

      {status && (
        <div className={getStatusAlertClass()} role="alert">
          {status.message}
        </div>
      )}

      {children}
    </div>
  );
}

export default SalesPageLayout;